"use client";

// react-scan must be imported before react
import { c as _c } from "react/compiler-runtime";
import { scan } from "react-scan";
import { useEffect } from "react";

/**
 * Functioon to enable ReactScan in development mode
 */
export function ReactScan() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
  return null;
}
function _temp() {
  return scan({
    enabled: process.env.NODE_ENV === "development"
  });
}